export default "__VITE_ASSET__DLnXa9UK__"